import { render } from "./ThoughtsPage.vue?vue&type=template&id=1f7e3e2f"
import script from "./ThoughtsPage.vue?vue&type=script&lang=js"
export * from "./ThoughtsPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/armenium/56-free-school-street/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__